// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f373ef5c","453":"7be2fd9d","732":"ed3448e6","977":"66a99064"}[chunkId] + ".chunk.js";
};